import React from 'react'
import SectionHeader from '../components/SectionHeader'
import BranchCard from '../components/cards/BranchCard'
// import { useTranslation } from 'react-i18next';

const AboutUsPage = () => {
  // const { t } = useTranslation();
  return (
    <section className='pt-[60px] pb-[32px]'>
    <SectionHeader title='Haqqımızda'/>
    <div className='container flex flex-col gap-2'>
      <p className='text-white font-semibold text-[20px]'>
      Ekrandakı ulduzların səmadakı ulduzlar kimi parladığı SkyCinema-ya xoş gəlmisiniz!
      </p>
      {/* <p className='text-white font-semibold text-[20px]'>
      Hal-hazırda iki filialı (Buzovna qəsəbəsi “Delmar Residence" istirahət kompleksi və Su idmanı Sarayı) mövcud olan sinemamız 2023-ci il tarixindən etibarən öz fəaliyyətinə başlamışdır.
      </p> */}
      <p className='text-white font-semibold text-[20px]'>
      İstər avtomobilinizdə, istərsə də isti aylarda rahat puflarımızda əlinizdə sevimli qəlyanaltılarla drive-in kinoteatrımızda rahatlıqla dincələ bilərsiniz. SkyCinema sizlərə tamaşaçıların sevimlisinə çevrilmiş filmlərin cazibəsininin sehrini yaşadacaq. Bütün müştərilərimizə zəngin kino təcrübəsini təmin etmək bizi irəli aparan əsas amildir. SkyCinema film izləməyi daha əyləncəli və daha atmosferli edən sevimli məkanınıza çevriləcək. Hər gəlişinizin yadda qalan xüsusi hadisə olacağı açıq səma altında əbədi hekayələrin canlandığı SkyCinemada bizə qoşulun.


      </p>
      <p className='text-white font-semibold text-[20px]'>
      Ulduzların altında görüşənədək!
      </p>
    </div>
    <SectionHeader title='Filiallarımız'/>
    <div className=' container w-full'>
      {/* <BranchCard
      carPrice='Maşınla (İnsan sayı asılı olmayaraq) - 20 AZN'
      // pufPrice={'Pufikdə (1 İnsan) - '}
      color={'purple'} 
      title={'SkyCinema Su İdman Sarayı'}
      link={'https://embed.waze.com/iframe?zoom=16&lat=40.333085&lon=49.836767&ct=livemap'}/> */}
      <BranchCard 
      carPrice='Maşınla (İnsan sayı asılı olmayaraq) - 15 AZN'
      color={'purple'}
      title={'SkyCinema Buzovna'}
      link={"https://embed.waze.com/iframe?zoom=16&lat=40.522764&lon=50.124731&ct=livemap" }/>
    </div>
    </section>
  )
}

export default AboutUsPage